import { delData, getData, patchData, postData } from '../../../utils/fetch-api-util';
import { API_URLS } from '../../../constants/urls/api-urls';

interface CartnerConvosRequest {
  //
}

export interface QuestionTypeResponse {
  questions: QuestionRecord[];
  total: number;
  limit: number;
  page: number;
}

export interface QuestionResponse {
  question: QuestionRecord;
}

export interface SummaryQuestionResponse {
  question: SummaryQuestionRecord;
}

export interface SummaryQuestionRecord {
  index?: number;
  id: string;
  title: string;
  description?: string;
  imageUrl?: string;
  disabled?: boolean;
  sortOrder?: number;
  createdAt?: string;
  isAnswered?: boolean;
  answers?: PercentAnswerRecord[];
  totalAnswer?: number;
}

export interface QuestionRecord {
  index?: number;
  id: string;
  title: string;
  description?: string;
  imageUrl?: string;
  disabled?: boolean;
  sortOrder?: number;
  createdAt?: string;
  isAnswered?: boolean;
  answers?: AnswerRecord[];
}

export interface PercentAnswerRecord {
  id: string;
  questionId?: string;
  answerTitle: string;
  answerDescription?: string;
  createdAt?: string;
  percent?: number;
  count?: number;
}

export interface AnswerRecord {
  id: string;
  questionId: string;
  answerTitle: string;
  answerDescription: string;
  createdAt?: string;
}

export interface QuestionPayload {
  title: string;
  imageUrl?: string;
  description?: string;
  options?: any;
}

export interface QuestionSchedulePayload {
  pollQuestionId?: string;
  activeAt?: string;
  id?: string;
  inActiveAt?: string;
  isRunActive?: boolean;
  isRunInActive?: boolean;
  questionTitle?: string;
}

export interface AnswerPayload {
  questionId: string;
  answerTitle: string;
  answerDescription?: string;
}

export interface QuestionStatusPayload {
  disabled: boolean;
}

interface SortQuestionPayload {
  sortQuestionList: {
    id: string;
    sortOrder: number;
  }[];
}

interface SuccessResponse {
  success: boolean;
}

export const getQuestionsRepository = async (request?: any): Promise<QuestionTypeResponse> => {
  const response = await getData<CartnerConvosRequest, QuestionTypeResponse>(API_URLS.QUESTION_LIST_API, request);
  return response.data;
};

export const getQuestionRepository = async (id: string): Promise<QuestionResponse> => {
  const response = await getData<CartnerConvosRequest, QuestionResponse>(API_URLS.QUESTION_URL_WITH_ID(id));
  return response.data;
};

export const getSummaryQuestionRepository = async (id: string): Promise<SummaryQuestionResponse> => {
  const response = await getData<CartnerConvosRequest, SummaryQuestionResponse>(API_URLS.QUESTION_PERCENT_API(id));
  return response.data;
};

export const postCreateQuestionRepository = async (payload: QuestionPayload): Promise<QuestionRecord> => {
  const response = await postData<QuestionPayload, QuestionRecord>(API_URLS.QUESTION_CREATE_API, payload);
  return response.data;
};

export const patchUpdateQuestionRepository = async (id: string, payload: QuestionPayload): Promise<QuestionRecord> => {
  const response = await patchData<QuestionPayload, QuestionRecord>(API_URLS.QUESTION_URL_WITH_ID(id), payload);
  return response.data;
};

export const postUpdateStatusQuestionRepository = async (
  id: string,
  payload: QuestionStatusPayload,
): Promise<QuestionRecord> => {
  const response = await postData<QuestionStatusPayload, QuestionRecord>(
    API_URLS.QUESTION_UPDATE_STATUS_API(id),
    payload,
  );
  return response.data;
};

export const postSortQuestionRepository = async (payload: SortQuestionPayload): Promise<void> => {
  await postData<SortQuestionPayload, SuccessResponse>(API_URLS.QUESTION_SORT, payload);
};

export const deleteQuestionRepository = async (id: string): Promise<void> => {
  await delData(API_URLS.QUESTION_URL_WITH_ID(id));
};

export const postCreateAnswerRepository = async (payload: AnswerPayload): Promise<AnswerRecord> => {
  const response = await postData<AnswerPayload, AnswerRecord>(API_URLS.ANSWER_CREATE_API, payload);
  return response.data;
};

export const patchUpdateAnswerRepository = async (id: string, payload: AnswerPayload): Promise<AnswerRecord> => {
  const response = await patchData<AnswerPayload, AnswerRecord>(API_URLS.ANSWER_URL_WITH_ID(id), payload);
  return response.data;
};

export const deleteAnswerRepository = async (id: string): Promise<void> => {
  await delData(API_URLS.ANSWER_URL_WITH_ID(id));
};

export const postUpdateQuestionScheduleRepository = async (
  payload: QuestionSchedulePayload,
): Promise<QuestionRecord> => {
  const response = await postData<QuestionSchedulePayload, QuestionRecord>(API_URLS.QUESTION_UPDATE_SCHEDULE, payload);
  return response.data;
};
